import React from 'react';
import BadGateway from 'app/components/pages/BadGateway';
import ContentSpinner from 'app/components/presentation/loading/ContentSpinner';
import makeLazyLoadingWrapper from 'app/components/mixins/makeLazyLoadingWrapper';
import PageWrapper from 'app/components/teacherRecruitment/PageWrapper';

const LoadingComponent = () => (
  <PageWrapper>
    <ContentSpinner />
  </PageWrapper>
);

const wrapComponent = makeLazyLoadingWrapper({
  LoadingComponent,
  ErrorComponent: BadGateway,
});

export default <T extends React.ComponentType<any>>(
  getModule: () => Promise<{ default: T }>,
) => wrapComponent(
  async () => (await getModule()).default,
);
